// ============================================
// HERO ФОРМА (ОБРАТНАЯ СВЯЗЬ)
// ============================================
document.addEventListener('DOMContentLoaded', function() {
    const heroSubmit = document.getElementById('heroSubmit');
    const heroName = document.getElementById('heroName');
    const heroPhone = document.getElementById('heroPhone');
    const heroConsent = document.getElementById('heroConsent');

    // Проверяем, есть ли элементы на странице
    if (!heroSubmit || !heroName || !heroPhone) {
        console.log('Hero форма не найдена на этой странице');
        return;
    }

    // ===== АВТОМАТИЧЕСКАЯ МАСКА ТЕЛЕФОНА =====
    function formatPhone(value) {
        let numbers = value.replace(/\D/g, '');
        if (numbers.length > 0 && (numbers[0] === '7' || numbers[0] === '8')) {
            numbers = numbers.substring(1);
        }
        if (numbers.length > 10) numbers = numbers.substring(0, 10);

        let formatted = '+7';
        if (numbers.length > 0) {
            formatted += ' (' + numbers.substring(0, 3);
        }
        if (numbers.length > 3) {
            formatted += ') ' + numbers.substring(3, 6);
        }
        if (numbers.length > 6) {
            formatted += '-' + numbers.substring(6, 8);
        }
        if (numbers.length > 8) {
            formatted += '-' + numbers.substring(8, 10);
        }
        return formatted;
    }

    heroPhone.addEventListener('input', function(e) {
        const cursorPos = e.target.selectionStart;
        const oldLength = e.target.value.length;
        const formatted = formatPhone(e.target.value);
        e.target.value = formatted;

        const newLength = formatted.length;
        const diff = newLength - oldLength;
        e.target.setSelectionRange(cursorPos + diff, cursorPos + diff);
    });

    heroPhone.addEventListener('focus', function() {
        if (this.value.trim() === '' || this.value === '+7') {
            this.value = '+7';
            setTimeout(() => {
                this.setSelectionRange(2, 2);
            }, 0);
        }
    });

    heroPhone.addEventListener('click', function() {
        if (this.value === '+7') {
            this.setSelectionRange(2, 2);
        }
    });

    // ===== ФУНКЦИЯ ПОКАЗА УВЕДОМЛЕНИЯ =====
    function showNotification(message, type = 'error') {
        const existingToast = document.querySelector('.custom-toast');
        if (existingToast) existingToast.remove();

        const toast = document.createElement('div');
        toast.className = `custom-toast custom-toast--${type}`;
        toast.textContent = message;
        document.body.appendChild(toast);

        setTimeout(() => toast.classList.add('show'), 10);
        setTimeout(() => {
            toast.classList.remove('show');
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    // ===== ВАЛИДАЦИЯ ТЕЛЕФОНА =====
    function validatePhone(phone) {
        const numbers = phone.replace(/\D/g, '');
        return numbers.length >= 11;
    }

    // ===== ОТПРАВКА ФОРМЫ =====
    heroSubmit.addEventListener('click', function(e) {
        e.preventDefault();

        const name = heroName.value.trim();
        const phone = heroPhone.value.trim();
        const isConsentChecked = heroConsent ? heroConsent.checked : false;

        // Валидация имени
        if (!name || name.length < 2) {
            showNotification('Введите ваше имя (минимум 2 символа)', 'warning');
            heroName.focus();
            return;
        }

        // Валидация телефона
        if (!validatePhone(phone)) {
            showNotification('Введите корректный номер телефона', 'warning');
            heroPhone.focus();
            return;
        }

        // Валидация согласия
        if (!isConsentChecked) {
            showNotification('Подтвердите согласие с политикой', 'warning');
            heroConsent?.focus();
            return;
        }

        // Блокируем кнопку
        const originalText = heroSubmit.textContent;
        heroSubmit.textContent = 'Отправка...';
        heroSubmit.disabled = true;

        // Отправляем только цифры телефона
        const phoneNumbers = phone.replace(/\D/g, '');

        const formData = new URLSearchParams({
            action: 'takt_submit_hero_form',
            nonce: takt_ajax.nonce,
            name: name,
            phone: phoneNumbers
        });

        fetch(takt_ajax.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showNotification('Заявка отправлена! Мы свяжемся с вами.', 'success');
                heroName.value = '';
                heroPhone.value = '+7';
                if (heroConsent) heroConsent.checked = false;
            } else {
                showNotification(data.data || 'Произошла ошибка. Попробуйте ещё раз.', 'error');
            }
        })
        .catch(error => {
            console.error('Ошибка:', error);
            showNotification('Ошибка соединения. Проверьте интернет.', 'error');
        })
        .finally(() => {
            heroSubmit.textContent = originalText;
            heroSubmit.disabled = false;
        });
    });
});

// ============================================
// INSURANCE ФОРМА
// ============================================
document.addEventListener('DOMContentLoaded', function() {
    const insuranceSubmit = document.getElementById('insuranceSubmit');
    const insuranceName = document.getElementById('insuranceName');
    const insurancePhone = document.getElementById('insurancePhone');
    const insuranceConsent = document.getElementById('insuranceConsent');

    // Проверяем, есть ли элементы на странице
    if (!insuranceSubmit) return;

    // ===== АВТОМАТИЧЕСКАЯ МАСКА ТЕЛЕФОНА =====
    if (insurancePhone) {
        function formatPhone(value) {
            let numbers = value.replace(/\D/g, '');
            if (numbers.length > 0 && (numbers[0] === '7' || numbers[0] === '8')) {
                numbers = numbers.substring(1);
            }
            if (numbers.length > 10) numbers = numbers.substring(0, 10);

            let formatted = '+7';
            if (numbers.length > 0) {
                formatted += ' (' + numbers.substring(0, 3);
            }
            if (numbers.length > 3) {
                formatted += ') ' + numbers.substring(3, 6);
            }
            if (numbers.length > 6) {
                formatted += '-' + numbers.substring(6, 8);
            }
            if (numbers.length > 8) {
                formatted += '-' + numbers.substring(8, 10);
            }
            return formatted;
        }

        insurancePhone.addEventListener('input', function(e) {
            const cursorPos = e.target.selectionStart;
            const oldLength = e.target.value.length;
            const formatted = formatPhone(e.target.value);
            e.target.value = formatted;

            const newLength = formatted.length;
            const diff = newLength - oldLength;
            e.target.setSelectionRange(cursorPos + diff, cursorPos + diff);
        });

        insurancePhone.addEventListener('focus', function() {
            if (this.value.trim() === '' || this.value === '+7') {
                this.value = '+7';
                setTimeout(() => {
                    this.setSelectionRange(2, 2);
                }, 0);
            }
        });

        insurancePhone.addEventListener('click', function() {
            if (this.value === '+7') {
                this.setSelectionRange(2, 2);
            }
        });
    }

    // ===== ФУНКЦИЯ ПОКАЗА УВЕДОМЛЕНИЯ =====
    function showNotification(message, type = 'error') {
        const existingToast = document.querySelector('.custom-toast');
        if (existingToast) existingToast.remove();

        const toast = document.createElement('div');
        toast.className = `custom-toast custom-toast--${type}`;
        toast.textContent = message;
        document.body.appendChild(toast);

        setTimeout(() => toast.classList.add('show'), 10);
        setTimeout(() => {
            toast.classList.remove('show');
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    // ===== ВАЛИДАЦИЯ =====
    function validatePhone(phone) {
        const numbers = phone.replace(/\D/g, '');
        return numbers.length >= 11;
    }

    function validateName(name) {
        return name.trim().length >= 2;
    }

    // ===== ОТПРАВКА ФОРМЫ =====
    insuranceSubmit.addEventListener('click', function(e) {
        e.preventDefault();

        const name = insuranceName ? insuranceName.value.trim() : '';
        const phone = insurancePhone ? insurancePhone.value.trim() : '';
        const isConsentChecked = insuranceConsent ? insuranceConsent.checked : false;

        // Валидация имени
        if (!validateName(name)) {
            showNotification('Введите ваше имя (минимум 2 символа)', 'warning');
            insuranceName?.focus();
            return;
        }

        // Валидация телефона
        if (!validatePhone(phone)) {
            showNotification('Введите корректный номер телефона', 'warning');
            insurancePhone?.focus();
            return;
        }

        // Валидация согласия
        if (!isConsentChecked) {
            showNotification('Подтвердите согласие с политикой', 'warning');
            insuranceConsent?.focus();
            return;
        }

        // Блокируем кнопку
        const originalText = insuranceSubmit.textContent;
        insuranceSubmit.textContent = 'Отправка...';
        insuranceSubmit.disabled = true;

        // Отправляем только цифры телефона
        const phoneNumbers = phone.replace(/\D/g, '');

        const formData = new URLSearchParams({
            action: 'takt_submit_insurance_form',
            nonce: takt_ajax.nonce,
            name: name,
            phone: phoneNumbers
        });

        fetch(takt_ajax.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                showNotification('Заявка отправлена! Мы свяжемся с вами.', 'success');
                if (insuranceName) insuranceName.value = '';
                if (insurancePhone) insurancePhone.value = '+7';
                if (insuranceConsent) insuranceConsent.checked = false;
            } else {
                showNotification(data.data || 'Произошла ошибка. Попробуйте ещё раз.', 'error');
            }
        })
        .catch(error => {
            console.error('Ошибка:', error);
            showNotification('Ошибка соединения. Проверьте интернет.', 'error');
        })
        .finally(() => {
            insuranceSubmit.textContent = originalText;
            insuranceSubmit.disabled = false;
        });
    });
});
